<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索链路名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          min-width="70"
          align="center"
          :formatter="formatterLinkType"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="frequency"
          label="频点"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="com_station_name"
          label="通讯站"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'linkList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'linkList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
      class="commonDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item label="链路名称" prop="name">
          <el-input
            v-model="commonForm.name"
            placeholder="请输入链路名称"
            maxlength="50"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item label="链路类型" prop="type" label-width="100px">
          <el-select
            v-model="commonForm.type"
            placeholder="请选择链路类型"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="type in linkTypes"
              :key="type.id"
              :label="type.name"
              :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="频点" prop="frequency">
          <el-input
            v-model.number="commonForm.frequency"
            placeholder="请输入频点"
            maxlength="4"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item label="通讯站" prop="com_station_id" label-width="100px">
          <el-select
            v-model="commonForm.com_station_id"
            placeholder="请选择通讯站"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="comStation in comStations"
              :key="comStation.id"
              :label="comStation.name"
              :value="comStation.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "linkList",
  props: ["menuId"],
  data() {
    return {
      queryForm: {},
      title: "添加链路",
      addPermission: null,
      buttonList: [],
      commonForm: {},
      current: 1, //当前页数
      size: 18, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addFlag: true,
      rules: {
        name: [
          { required: true, trigger: "blur", message: "链路名称不能为空~" },
        ],
        type: [{ required: false, trigger: "blur" }],
        frequency: [
          { required: false, trigger: "blur" },
          {
            type: "number",
            min: 1,
            max: 3000,
            message: "频点在1-3000之间~",
          },
        ],
        com_station_id: [{ required: false, trigger: "blur" }],
      },
      comStations: [], //区域
      linkTypes: [
        {
          id: 0,
          name: "M4G",
        },
        {
          id: 1,
          name: "J4G",
        },
        {
          id: 2,
          name: "M5G",
        },
        {
          id: 3,
          name: "J5G",
        },
        {
          id: 4,
          name: "电台",
        },
        {
          id: 5,
          name: "卫通",
        },
      ],
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "linkList-add") {
              this.addPermission = child;
            } else if (child.path !== "linkList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    add() {
      this.$data.title = "添加链路";
      this.queryComStation();
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addStation();
        } else if (valid && !this.$data.addFlag) {
          this.editStation();
        } else {
          return false;
        }
      });
    },
    addStation() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/airlink/addAirLink.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    queryComStation() {
      let vue = this;
      this.getRequest("/basic-info-server/commstation/getAllCommStationList.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.comStations = res.data;
            } else {
              this.$data.comStations = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/airlink/getAirLinkList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/airlink/getAirLinkById.do", {
        id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改链路";
              this.queryComStation();
              this.$data.addFlag = false;
              try {
                if (res.data.frequency) {
                  res.data.frequency = parseInt(res.data.frequency);
                }
              } catch (error) {}
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑提交
    editStation() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/airlink/upateAirLink.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/airlink/DelAirLink.do", row)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    formatterLinkType(row, column, value) {
      if (this.$data.linkTypes[value]) {
        return this.$data.linkTypes[value].name;
      }
      return "";
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.commonForm = {};
      }
      this.defaultClearValidate();
    },
  },
};
</script>

<style>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}

.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-linkList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 261px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/link/airLink.vue